import React, { useEffect, useState } from 'react'
import useDropdown from '../context/useDropdown'
import { MODE, filterIsDeleted } from '../constant'
import { Col, Row, Typography, message } from 'antd'
import SelectUC from '../../../components/Form/SelectUC'
import ButtonUC from '../../../components/buttonUC'
import InputUC from '../../../components/Form/InputUC'
import RadioUC from '../../../components/Form/RadioUC'
import HeaderBarAdd from '../headerBarAdd'
import BtnEditUC from '../../../components/Form/BtnEditUC'
import BtnDeleteUC from '../../../components/Form/BtnDeleteUC'
import AutoCompleteUC from '../../../components/Form/AutoCompleteUC'

const GeneralCapability = ({ props }) => {
    const {
        form,
        rcAppProfileCapability,
        setRcAppProfileCapability,
        rcDeletedData,
        setRcDeletedData } = props

    const { Text } = Typography
    const [mode, setMode] = useState(MODE.VIEW) //view, edit
    const { ddlCapability, ddlCapabilityLevel, getDDLLabel } = useDropdown()
    const [option, setOption] = useState('capability')
    const [isReq, setReq] = useState(false)

    useEffect(() => {
        setReq(mode === MODE.EDIT)
    }, [mode])

    const handleAdd = () => {
        console.log('handleAdd')
        // new
        let newRow = {
            sort: 1,
            capabilityId: null,
            levelId: null,
            option: 'capability'
        }

        if (rcAppProfileCapability && rcAppProfileCapability.length > 0) {
            const max = Math.max(...rcAppProfileCapability.map(o => o.sort))
            newRow = {
                ...newRow,
                sort: max + 1,
            }
        }

        setForm(newRow)
        setMode(MODE.EDIT)
    }

    const setForm = (record) => {
        form.setFieldsValue({
            cap_sort: record.sort,
            cap_capabilityId: record.id ? record.capabilityName : record.capabilityId,
            cap_capabilityName: record.option === 'other' ? record.capabilityName : "",
            cap_levelId: record.option !== 'other' ? record.levelId : null,
            cap_otherLevelId: record.option === 'other' ? record.otherLevelId : null,
            cap_option: record.option,
        })

        setOption(record.option)
    }

    const handleEdit = (record) => {
        console.log('handleEdit', record)
        if (record) {
            setForm(record)
            setMode(MODE.EDIT)
        }
    }

    const handleDelete = (record) => {
        if (record.id) {
            // เก็บ Record ที่ลบ
            setRcDeletedData([...rcDeletedData, { id: record.id, tableName: 'appProfileCapability' }])
        }
        setRcAppProfileCapability(rcAppProfileCapability.filter(r => r.sort !== record.sort))
    }

    const handleCancel = () => {
        setMode(MODE.VIEW)
    }

    const handleSubmit = () => {
        console.log('handleSubmit')
        const dataPreSubmit = {
            sort: form.getFieldValue('cap_sort'),
            capabilityId: form.getFieldValue('cap_capabilityId'),
            capabilityName: form.getFieldValue('cap_capabilityName'),
            levelId: form.getFieldValue('cap_levelId'),
            otherLevelId: form.getFieldValue('cap_otherLevelId'),
            option: form.getFieldValue('cap_option'),
        }

        const dataColValidate1 = [
            { caption: "กรุณาเลือกความสามารถ", columnName: "cap_capabilityId" },
            { caption: "กรุณาเลือกระดับความสามารถ", columnName: "cap_levelId" },
        ]

        const dataColValidate2 = [
            { caption: "กรุณากรอกอื่น ๆ", columnName: "cap_capabilityName" },
            { caption: "กรุณาเลือกระดับความสามารถ", columnName: "cap_otherLevelId" }
        ]

        let isValidate = false
        if (dataPreSubmit.option !== 'other') {
            dataColValidate1.forEach(el => {
                const _isValidate = checvalidateDraft(el)
                isValidate = isValidate ? isValidate : (_isValidate ?? false)
            })
        } else {
            dataColValidate2.forEach(el => {
                const _isValidate = checvalidateDraft(el)
                isValidate = isValidate ? isValidate : (_isValidate ?? false)
            })
        }

        if (isValidate) {
            message.warning('กรุณากรอกข้อมูลความสามารถทั่วไป');
            return false
        } else {
            const row = rcAppProfileCapability && rcAppProfileCapability.filter(item => item.sort === dataPreSubmit.sort)
            if (row && row.length > 0) {
                setRcAppProfileCapability(rcAppProfileCapability.map((obj) => obj.sort === dataPreSubmit.sort ? dataPreSubmit : obj))
            } else {
                setRcAppProfileCapability([...rcAppProfileCapability, dataPreSubmit])
            }

            setMode(MODE.VIEW)
        }
    }

    const checvalidateDraft = (e) => {
        const _data = form.getFieldValue([e.columnName])
        if (!_data || _data === '') {
            form.setFields([
                {
                    name: [e.columnName],
                    errors: [e.caption],
                },
            ]);
            return true
        }
        return false
    }

    const setDataCapability = (data) => {
        return (data.option !== 'other') ? (ddlCapability?.find(e => e.id === data.capabilityId)?.value ?? (data.capabilityId ?? data.capabilityName)) : data.capabilityName
    }

    const FormView = ({ data }) => {
        const _capability = setDataCapability(data)
        const _level = getDDLLabel(ddlCapabilityLevel, data.option === 'capability' ? data.levelId : data.otherLevelId)
        return (
            <>
                <Row className="py-2 p-3 justify-between">
                    <Col xs={24} md={8} className='px-2 flex items-center'>
                        <Text className='text-capability color-secondary1'>{_capability}</Text>
                    </Col>
                    <Col xs={24} md={8} className='px-2 flex items-center'>
                        <Text className='text-level mr-1'>ระดับความสามารถ:</Text>
                        <Text className='text-level color-gray6'>{_level}</Text>
                    </Col>
                    <Col xs={24} md={8} className='px-2'>
                        <div className="flex justify-end">
                            <BtnEditUC disabled={data.isCanNotEdit === true} handleEdit={() => handleEdit(data)} />
                            <BtnDeleteUC disabled={data.isCanNotDelete === true} handleDelete={() => handleDelete(data)} />
                        </div>
                    </Col>
                </Row>
            </>
        )
    }


    const childCapability = () => {
        return (
            <>
                <Col xs={22} md={14} className='px-2'>
                    <AutoCompleteUC
                        required={isReq}
                        label='ความสามารถ'
                        name={'cap_capabilityId'}
                        maxLength={50}
                        options={ddlCapability?.filter(filterIsDeleted)}
                        disabled={option === 'other'} />
                </Col>
                <Col xs={24} md={8} className='px-2'>
                    <SelectUC
                        required={isReq}
                        label='ระดับความสามารถ'
                        name={'cap_levelId'}
                        optionValues={ddlCapabilityLevel?.filter(filterIsDeleted)}
                        disabled={option === 'other'} />
                </Col>
            </>
        )
    }

    const childOther = () => {
        return (
            <>
                <Col xs={22} md={14} className='px-2'>
                    <InputUC
                        required={isReq}
                        label='อื่น ๆ'
                        name={'cap_capabilityName'}
                        maxLength={50}
                        disabled={option === 'capability'} />
                </Col>
                <Col xs={24} md={8} className='px-2'>
                    <SelectUC
                        required={isReq}
                        label='ระดับความสามารถ'
                        name={'cap_otherLevelId'}
                        optionValues={ddlCapabilityLevel?.filter(filterIsDeleted)}
                        disabled={option === 'capability'} />
                </Col>
            </>
        )
    }

    const childrenRadio = [
        { value: "capability", index: 1, child: childCapability() },
        { value: "other", index: 2, child: childOther() }
    ]

    const onChangeCapability = (e) => {

        if (e.target.value === 'capability') {
            form.setFieldsValue({
                cap_capabilityName: null,
                cap_otherLevelId: null,
            })
        } else {
            form.setFieldsValue({
                cap_capabilityId: null,
                cap_levelId: null,
            })
        }

        form.setFieldsValue({
            cap_option: e.target.value
        })

        setOption(e.target.value)
    }

    const setFormEdit = (e) => {
        let cap_capability = null, cap_level = null, cap_otherLevel = null
        if (ddlCapability.filter(filterIsDeleted)?.length > 0) {
            cap_capability = ddlCapability.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('cap_capabilityId'))
        }
        if (ddlCapabilityLevel.filter(filterIsDeleted)?.length > 0) {
            cap_level = ddlCapabilityLevel.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('cap_levelId'))
        }
        if (ddlCapabilityLevel.filter(filterIsDeleted)?.length > 0) {
            cap_otherLevel = ddlCapabilityLevel.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('cap_otherLevelId'))
        }

        form.setFieldsValue({
            cap_capabilityId: cap_capability ? cap_capability.value : (option !== 'other' ? form.getFieldValue('cap_capabilityId') : null),
            cap_levelId: cap_level ? cap_level.value : null,
            cap_otherLevelId: cap_otherLevel ? cap_otherLevel.value : null
        })
    }

    const FormEdit = () => {
        setFormEdit()
        return (
            <>
                <Row className="py-2">
                    <Col span={0} className={'hidden'}>
                        <Text name={'cap_sort'}></Text>
                    </Col>
                    <Col span={24}>
                        <RadioUC
                            name="cap_radio"
                            children={childrenRadio}
                            showLabel={false}
                            labelSpan={2}
                            childSpan={24}
                            handleChange={onChangeCapability}
                            value={form.getFieldValue("cap_option")}
                        />
                    </Col>
                </Row>
                <Row className="py-2">
                    <Col span={24} className='px-2 flex justify-end'>
                        <ButtonUC className='btn-clear mr-3' onClick={() => handleCancel()}>ยกเลิก</ButtonUC>
                        <ButtonUC className='btn-custom ml-3' onClick={() => handleSubmit()}>บันทึก</ButtonUC>
                    </Col>
                </Row>
            </>
        )
    }

    return (
        <div className='div-cap-lang w-full'>
            <HeaderBarAdd title={'ความสามารถทั่วไป'} handleAdd={handleAdd} disabled={mode === 'edit'} />
            {mode === 'view' && rcAppProfileCapability && rcAppProfileCapability.length > 0 ?
                <>
                    {rcAppProfileCapability.map((item, index) => {
                        return (
                            <FormView key={index} data={item} />
                        )
                    })}
                </>
                : <>{mode === 'edit' && <FormEdit />}</>}
        </div>
    )
}

export default GeneralCapability